// 审核状态
export const examineType = {
  'IN_REVIEW': { text: "审核中", status: 'Error' },
  'PASS': { text: "审核通过", status: 'Success' },
} as const;

// 检测类型
export const businessType = {
  'FACE': { text: "面诊" },
  'PULSE': { text: "脉诊" },
  'TONGUE': { text: "AI舌诊" },
  'CORPOREALITY': { text: "体质检测" },
  'FOOD_RECOGNITION': { text: "AI识菜" },
  'OTHER': { text: "其他" },
} as const;

// 检测状态
export const checkStatusType: any = {
  'FAILED': { text: "失败" },
  'CHECK_SUCCESS': { text: "检测成功" },
  'PARSED_SUCCESS': { text: "解析成功" },
  'LABELED_SUCCESS': { text: "标注成功" },
} as const;

// 体质信息
export const contitutionType = {
  'population_characteristics': { text: "群体特征" },
  'disease_predisposition': { text: "发病倾向" },
  'dietary_recommendations': { text: "食疗建议" },
  'dietary_recommendations_suitable': { text: "食疗建议-宜" },
  'dietary_recommendations_avoid': { text: "食疗建议-忌" },
  'common_symptom': { text: "常见表现" },
  'treatment_approach': { text: "调理思路" },
} as const;

// 建议
export const suggestionsType = {
  'overall_suggestion': { text: "总体建议" },
  'emotion_regulation': { text: "情志调摄" },
  'diet_regulation': { text: "饮食调节" },
  'exercise_regulation': { text: "运动健身" },
  'live_regulation': { text: "起居调节" },
  'herbal_regulation': { text: "药饵保健" },
} as const;

// 会员套餐标签类型
export const labelType = {
  'DEFAULT': { text: "默认" },
  'TIME_LIMIT': { text: "限时" },
  'OFFER': { text: "优惠" },
  'HOT': { text: "热门" },
} as const;

// 会员套餐会员类型
export const vipType = {
  'DATE': { text: "日卡" },
  'MONTH': { text: "月卡" },
  'YEAR': { text: "年卡" },
  'CONTINUOUS_MONTHLY': { text: "连续包月" },
  'CONTINUOUS_QUARTERLY': { text: "连续包季" },
  'CONTINUOUS_YEARLY': { text: "连续包年" },
  'PERMANENT': { text: "永久" },
} as const;

// 会员套餐支付方式
export const payType = {
  'WECHAT': { text: "微信" },
  'ALIPAY': { text: "支付宝" },
  'APPLE': { text: "苹果" },
  'APPLE_AUTO': { text: "苹果自动续订" },
} as const;

// 支付状态
export const payStatus = {
  'UN_PAY': { text: "未支付", status: 'Warning' },
  'PAID': { text: "已支付", status: 'Success' },
  'EXPIRED': { text: "已过期", status: 'Default' },
  'CANCELED': { text: "已关闭", status: 'Default' },
} as const;

// 业务类型
export const operatorType = {
  'VIP': { text: "会员" },
} as const;

// 设备类型
export const deviceType = {
  'IOS': { text: "ios" },
  'ANDROID': { text: "安卓" },
} as const;

// 登录渠道
export const loginChannel = {
  'DEVICE': { text: "设备登录", color: "orange" },
  'WECHAT': { text: "微信登录", color: "green" },
  'APPLE': { text: "苹果登录", color: "red" },
  'PHONE': { text: "手机号登录", color: "blue" },
  'ONE_CLICK': { text: "一键登录", color: "purple" },
} as const;

// 弹窗反馈类别
export const popupCategory = {
  'DAILY_HEALTH': { text: "每日养生" },
} as const;
